document.addEventListener("DOMContentLoaded", () => {

  function initPlayButtonWatcher() {
    const playButton = document.querySelector(".play-button");
    const video = document.querySelector("video");

    if (!playButton || !video) {
      // Retry until both exist (Shopify often lazy-loads video sections)
      return setTimeout(initPlayButtonWatcher, 400);
    }

    // --- Helper: detect if button is in "playing" mode ---
    const isPlaying = () => {
      const pauseIcon = playButton.querySelector(".icon-pause");
      return pauseIcon && window.getComputedStyle(pauseIcon).display !== "none";
    };

    // --- Fade logic ---
    const fadeOut = () => {
      playButton.style.transition = "opacity 0.4s ease";
      playButton.style.opacity = "0";
      playButton.style.pointerEvents = "none";
    };

    const fadeIn = () => {
      observer.disconnect(); // avoid mutation loops
      playButton.style.transition = "opacity 0.4s ease";
      playButton.style.opacity = "1";
      playButton.style.pointerEvents = "auto";
      setTimeout(() => {
        observer.observe(playButton, {
          attributes: true,
          subtree: true,
          attributeFilter: ["style", "class"]
        });
      }, 450);
    };

    // --- Mutation observer to detect SVG toggle (play/pause icon change) ---
    const observer = new MutationObserver(() => {
      if (isPlaying()) fadeOut();
    });

    observer.observe(playButton, {
      attributes: true,
      subtree: true,
      attributeFilter: ["style", "class"]
    });

    // --- Video event listeners ---
    video.addEventListener("play", fadeOut);
    video.addEventListener("pause", fadeIn);
    video.addEventListener("ended", fadeIn);

    // --- Fallback interval (in case play starts via JS, no events triggered) ---
    const interval = setInterval(() => {
      if (isPlaying()) {
        fadeOut();
        clearInterval(interval);
      }
    }, 500);
  }

  initPlayButtonWatcher();
});